import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useMutation } from "@tanstack/react-query";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";

/**
 * Décisions de retrait — nominatives et motivées.
 * Le serveur enregistre decidedById (traçabilité audit) et exige un motif
 * pour tout rejet ; le client invalide file + KPI + notifications.
 */
const invalidateAll = () => {
  queryClient.invalidateQueries({ queryKey: ["withdrawals"] });
  queryClient.invalidateQueries({ queryKey: ["withdrawal-stats"] });
  queryClient.invalidateQueries({ queryKey: ["notifications"] });
};

export const validate = async (id: string, note?: string) => {
  const response = await axios.patch<WithdrawalWithUser>(`withdrawals/accept/${id}`, { note });
  return response.data;
};

export const useValidate = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: validateFn,
  } = useMutation({
    mutationFn: ({ id, note }: { id: string; note?: string }) => validate(id, note),
    onSuccess: invalidateAll,
    onError: invalidateAll,
  });

  return { validate: validateFn, loading, error };
};

export const reject = async (id: string, note: string) => {
  const response = await axios.patch<WithdrawalWithUser>(`withdrawals/reject/${id}`, { note });
  return response.data;
};

export const useReject = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: rejectFn,
  } = useMutation({
    mutationFn: ({ id, note }: { id: string; note: string }) => reject(id, note),
    onSuccess: invalidateAll,
    onError: invalidateAll,
  });

  return { reject: rejectFn, loading, error };
};
